import PageHeader from "./PageHeader";

export default function ReturnsAndExchangePolicy() {
  return (
    <>
      <PageHeader seoKey={"returnsAndExchangePolicy"} />
      <section className="container py-5">
        <div className="row g-4">
          <div className="col-lg-12">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-4">
                <h5 className="fw-bold mb-4">Returns & Exchange Policy</h5>

                <ol className="mb-4">
                  <li>
                    Aura Skin Premium accepts returns or exchanges within{" "}
                    <strong>10 days of purchase</strong>. Products must be
                    unused, in their original condition, and with the original
                    packaging intact.
                  </li>
                  <li>
                    Please include a copy of the invoice and mention the reason
                    for returning the items.
                  </li>
                  <li>
                    Customers must return the merchandise via a traceable
                    courier service or registered post at their own expense to
                    our address.
                  </li>
                  <li>Delivery charges will not be refunded.</li>
                  <li>
                    If the items received are not as per the order placed,{" "}
                    <strong>Aura Skin Premium</strong> will bear all delivery
                    charges for return or exchange. In such cases, the parcel
                    will be picked up by our team via courier.
                  </li>
                  <li>
                    Refund or exchange requests will be processed within{" "}
                    <strong>7 working days</strong> after receiving the returned
                    products.
                  </li>
                  <li>
                    All returns should be sent to:{" "}
                    <strong>
                      Aura Skin Premium, Awan Town, Pak Post Office, Lahore,
                      54780
                    </strong>
                  </li>
                </ol>

                <p className="text-muted mb-0">
                  For any return or exchange assistance, please email us at{" "}
                  <strong>auraskinpremium@gmail.com</strong> or WhatsApp{" "}
                  <strong>0311-7266767</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
